import ModelComboBoxAsync, { ModelComboBoxPropsAsync } from "@/components/inputs/components/combo-box/model-combo-box-async";
import RegisterField, { FieldProps } from "../register-field";
import { BaseQuery } from "@/shared/types/base";

export default function FormModelComboBoxAsync<T extends ({ id: string } & Record<string, any>), P extends BaseQuery>({
    name,
    registerOptions,
    ...props
}: FieldProps<ModelComboBoxPropsAsync<T, P>>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <ModelComboBoxAsync
            {...props}

            ref={field.ref}
            value={field.value}
            disabled={field.disabled}

            setValue={v => {
                field.handleChange(v);
                props.setValue && props.setValue(v);
                props.onValueChange && props.onValueChange(v);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}